module.exports = __webpack_public_path__ + "pattern4.88ab8ad95a8055d0f3dc";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/assets/images/pattern4.png
// module id = ../../../../../src/assets/images/pattern4.png
// module chunks = styles